import {
  AbsolutesWhiteColors,
  BackgroundColors,
  ErrorColors,
  NegativeColors,
  PositiveColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { Easing } from '@picsart/design-system/foundation/easing';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      backgroundColor: BackgroundColors.base,
      padding: [Spacings.s64, Spacings.s56],

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s64, Spacings.s44],
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s32],
      },

      '& > .quote-icon': {
        margin: [Spacings.s0, 'auto', 86],
        width: 56,
        height: 56,
        display: 'block',
        fill: ErrorColors.base.default,
      },

      '& $carouselControl': {
        '&.prev': {
          left: Spacings.s4,
          '&.disabled': {
            transform: 'translateX(-10px)',
          },
        },

        '&.next': {
          right: Spacings.s4,
          '&.disabled': {
            transform: 'translateX(10px)',
          },
        },
      },
    },
    carouselControl: {
      transition: `translateX, opacity, visibility, ${Timings.default} ${Easing.easeInOut}`,
      alignItems: 'center',
      display: 'flex',

      '& button': {
        boxShadow: `0 4px 8px ${BackgroundColors.tint3}`,
        backgroundColor: PositiveColors.base.default,
        borderRadius: CornerRadius.r16,
        height: 36,
        width: 36,

        '& svg': {
          width: 12,
          margin: [Spacings.s0, 'auto'],

          '& path': {
            fill: NegativeColors.base.default,
          },
        },
      },

      '&.next, &.prev': {
        height: 'calc(100% - 180px)',

        '&.disabled': {
          opacity: 0,
          visibility: 'hidden',
        },
      },
    },
    carouselContainer: {
      margin: 'auto',
      maxWidth: 1282,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& > div': {
        width: '100%',
        maxWidth: '100%',
        margin: [Spacings.s0, 'auto'],

        '&$carouselDots': {
          marginTop: 84,
        },
      },
    },
    carouselDots: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      height: 34,

      '& button': {
        border: `4px solid ${PrimaryColors.base.default}`,
        transition: `all .2s ${Easing.easeIn}`,
        background: AbsolutesWhiteColors.base.default,
        height: 8,
        width: 8,

        '&.active': {
          background: AbsolutesWhiteColors.base.default,
          borderWidth: 3,
          height: 14,
          width: 14,
        },
      },
    },

    // SKELETON
    quotesFallback: {
      width: 56,
      height: 56,
    },
    carouselFallback: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 80,

      '& > i': {
        height: 160,
        maxWidth: 252,
        margin: [Spacings.s0, 'auto'],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr',
      },
    },
  }),
  {
    name: 'Testimonial-with-card-design',
  },
);

export default useStyles;
